<template>
  <Container>
    <div class="flex-wrap flex-between" style="padding:0 10px">
      <Toolbar
        :items="tools"
        v-model="filter"
        :counts="counts"
        @on-event="handleEvent"
      />

      <div class="flex-wrap">
      <Button style="margin-right:5px" icon="md-add" type="primary" @click="showCreateForm">新建项目</Button>
      <Button style="margin-left:5px" icon="md-download" @click="exportExcel" />
      </div>
    </div>

    <div class="table-wrap" style="flex-grow:1;position;relative">
      <BaseTable
        ref="table"
        :columns="columns"
        :data="items"
        border
        :page="page"
        :page-size="pagesize"
        @event="handleEvent"
        :loading="loading"
        :count="total"
      />
    </div>

    <Editor
      ref="editor"
      v-model="showEditor"
      :width="900"
      :data="current"
      model="BU_Bid_Work_Project"
      @on-event="handleEvent"
    />
  </Container>
</template>

<script>
import Container from '@/components/app/container';
import Toolbar from '@/components/app/toolbar';
import Editor from '@/components/model/editor';
import moment from 'moment';
export default {
  routerOption: {
    as_default: true,
  },
  components: {Container, Toolbar, Editor},
  data() {
    return {
      filter: {

      },
      showEditor: false,
      items: [],
      loading: false,
      current: {},
      formData: {},
      page: 1,
      pagesize: 20,
      total: 10,
      counts: {
        '草稿': 0,
        '审核中': 0,
        '审核通过': 0,
        '不通过': 0,
      },
      order: {},
    };
  },
  methods: {
    showCreateForm() {
      this.current = {};
      this.formData = {};
      this.showEditor = true;
    },
    Edit(item) {
      this.loadingEditor = true;
      this.showEditor = true;
      this.$api.get(`business/bid_work_projects/${item.id}?edit=1`).then((res)=>{
        this.current = res.data.data;
        this.loadingEditor = false;
        this.formData = cloneDeep(this.current);
        this.showEditor = true;
      }).catch((e)=>{
        this.loadingEditor = false;
        this.loadingEditorError = true;
      });
    },
    getStatusCounts() {
      this.$api.getCounts('/business/bid_work_projects', {
        count_by: 'status',
      }).then((res)=>{
        this.counts = Object.assign(this.counts, res.data.data);
      });
    },
    exportExcel() {
      this.$refs.table.exportExcel();
    },
    getData() {
      this.loading = true;
      this.$api.getPaged('/business/bid_work_projects', {
        page: this.page,
        pagesize: this.pagesize,
        order: this.order,
        filter: this.filter,
        related: ['bid_info', 'project_info', 'bid_bond','bid_files'],
        plain:true
      }).then((res)=>{
        const {count, list} = res.data.data;
        list.forEach((l)=>{
          Object.assign(l, l.project_info);
          Object.assign(l, l.bid_info);
          if (l.bid_bond) {
            delete l.bid_bond.id;
            delete l.bid_bond.project_id;
            Object.assign(l, l.bid_bond);
          }
        });
        this.items = list;
        this.total = count;
        this.loading = false;
      });
    },
    createItem(model) {
      this.$api.post('/business/bid_work_projects', model).then((res)=>{
        this.$Notice.success({title: '创建成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    },
    updateItem(model) {
      const id = this.current.id;
      this.$api.patch(`/business/bid_work_projects/${id}`, model).then((res)=>{
        this.$Notice.success({title: '修改成功'});
        this.showEditor = false;
        this.getData();
      }).finally(()=>{
        this.$refs.editor.stopLoading();
      });
    },
    CreateNext(item) {
      this.Confirm(`将为项目创建<span style='color:red;margin:0 3px'>${item.name}</span>创建对应的开标工作, 是否继续?`, ()=>{
        this.loading = true;
        this.$api.post('/business/bid_work_projects/create-work', {id: item.id}).then((res)=>{
          this.Confirm('开标工作已经创建成功,是否跳转', ()=>{
            this.RouteTo('open');
          });
        }).catch((e)=>{
          this.Error(e);
        }).finally(()=>{
          this.loading = false;
        });
      });
    },
    handleDelete(item) {
      this.Confirm(`即将删除此项目<span style="color:var(--error)">${item.name}</span>，是否继续?`, ()=>{
        this.$api.delete('/business/bid_work_projects/'+item.id).then((res)=>{
          this.$Notice.success({title: '删除成功'});
          this.getData();
        });
      });
    },
    handleOpen(project) {
      this.$store.commit('session/push_project', {
        id: project.id,
        name: project.name,
      });
      this.RouteTo('/core/projects/'+project.id+'/bid');
    },
    handleEvent({type, key, value, data}) {
      const eventMap = {
        'add': this.showCreateForm,
        'search': this.getData,
        'create': this.createItem,
        'refresh': ()=>{
          this.getStatusCounts();
          this.getData();
        },
        'update': this.updateItem,
        'tab-change': this.getData,
        'page-change': ()=>{
          this.page = data;
          this.getData();
        },
        'page-size-change': ()=>{
          this.pagesize = data;
          this.getData();
        },
        'sort': ()=>{
          if (!data || !data.key) {
            this.order = null;
          } else {
            this.order = data;
          }
          this.getData();
        },
      };


      let eventHandler = eventMap[type];
      if (eventHandler) {
        eventHandler(value);
      } else {
        eventHandler = eventMap[key];
        if (eventHandler) {
          eventHandler(value);
        }
      }
    },
  },
  computed: {
    tools() {
      return [{
        key: 'search',
        placeholder: '输入项目名称/招标单位/搜索',
        type: 'search',
        maxWidth: 200,
      }, {
        key: 'status',
        type: 'tabs',
        showTotal: true,
        subs: [{
          key: '准备中',
          icon: 'date',
          countable: true,
          name: '准备中',
        }, {
          key: '工作分配',
          icon: 'file',
          countable: true,
          name: '工作分配',
        }, {
          key: '人员选配',
          icon: 'file',
          countable: true,
          name: '人员选配',
        }, {
          key: '业绩准备',
          icon: 'file',
          countable: true,
          name: '业绩准备',
        }, {
          key: '标书撰写',
          icon: 'file',
          countable: true,
          name: '标书撰写',
        }, {
          key: '内部审核',
          icon: 'file',
          countable: true,
          name: '内部审核',
        }, {
          key: '已投标',
          icon: 'file',
          countable: true,
          name: '已投标',
        }],
      }, {
        key: 'refresh',
        icon: 'md-refresh',
        type: 'icon-button',
      }];
    },
    columns() {
      const that = this;
      return [
        {type: 'index', width: 80, title: '序号'},
        {key: 'code', width: 80, title: '编号'},
        {key: 'name', minWidth: 200, title: '项目名称', sortable: 'custom',
          render: (h, {row})=>{
            const icon = h('BaseIcon', {props: {icon: 'Building-', size: 16, color: 'var(--primary)'}, style: 'margin-left:10px;margin-right:5px;'});
            let tag = h('img', {attrs: {
              src: 'https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif',
            }, style: 'width:30px;height:15px;margin-left:5px;margin-right:10px;'});
            if (moment().subtract(3, 'days').isAfter(moment(row.created_by))) {
              tag = '';
            }
            const name = h('div', {attrs: {title: row.name}, style: 'white-space:nowrap;text-overflow:ellipsis;width:calc(100% - 50px;);overflow:hidden;'}, row.shortname || row.name);
            return h('div', {
              class: 'flex-wrap',
              style: {
                color: 'var(--primary)',
                fontWeight: 'bold',
                textAlign: 'left',
                cursor: 'pointer',
              },
              on: {
                click: ()=>{
                  this.Edit(row);
                },
              },
            }, [icon, name, tag]);
          },
        },
        {
          key: 'status', width: 100,
          type: 'state',
          title: '项目进度', sortable: 'custom',
        },
        {key: 'charger_id', type: 'user', width: 120, title: '总负责人', sortable: 'custom',

        },
        {key: 'commericial_charger_id', type: 'user', width: 120, title: '商务标', sortable: 'custom',

        },
        {key: 'techical_charger_id', type: 'user', width: 120, title: '技术标', sortable: 'custom',

        },
        {key: 'qualification_charger_id', type: 'user', width: 120, title: '资信标', sortable: 'custom',

        },
        {key: 'verify_charger_id', type: 'user', width: 120, title: '内部审核', sortable: 'custom',

        },

        {key: 'opened_at', width: 120, title: '开标日期', type: 'time', option: {type: 'deadline',limit:7}},
        {key: 'personel', type: 'users', width: 140, title: '人员选配', sortable: 'custom',

        },
        {
          key: 'deposit_amount', type: 'number', option: {type: 'amount'}, width: 100, title: '投标保证金', sortable: 'custom',
        },
        {
          key: 'bid_bond_deadline', type: 'time', option: {type: 'deadline', limit: 3}, width: 180, title: '保证金截止日期', sortable: 'custom',
        },
        {
          key: 'bid_files', type: 'file', width: 120, title: '投标文件', sortable: 'custom',
        },

        {key: 'tools', width: 140, title: '操作', sortable: false, fixed: 'right',
          render: (h, {row})=>{
            const buttons = [
              h('Button', {props: {size: 'small'}, on: {click: ()=>{
                that.Edit(row);
              }}}, '修改'),
              h('Button', {props: {size: 'small'}, on: {click: ()=>{
                that.handleDelete(row);
              }}}, '删除'),
              h('Button', {props: {size: 'small', type: 'primary'}, on: {click: ()=>{
                that.CreateNext(row);
              }}}, '创建工作'),
            ];
            return h('div', {class: 'flex'}, [buttons]);
          },
        },
      ];
    },
  },
  mounted() {
    this.getData();
    this.getStatusCounts();
    this.$nextTick(()=>{
      if (this.$refs && this.$refs.table && this.$refs.table.calcTableHeight) {
        this.$refs.table.calcTableHeight();
      }
    });
  },
};
</script>

<style lange="less">
.filter-box{
  height:50px;
}

.table-wrap{
  height:calc(100% - 50px);
  position: relative;
}

</style>
